import './ContentPage.css';
import Footer from '../components/Footer.js'; 

const Quality = ({ title, content }) => {
  return (
    <div>
    <div className="content-page">
      <section className="content-hero">
        <h1 className="hero-title">Assurance of Quality Service</h1>
        <div className="hero-decor"></div>
      </section>

      <section className="content-section">
        <div className="content-card reveal active">

          <div className="text-container">
            <p className="content-text">In line with the firm's mission of providing high-quality services that guarantee value for money, we have established a Client Services Supervision (CSS) department responsible for maintaining close liaisons with clients.

The department deals with clients' complaints on service delivery/quality.

Attends to service requests from clients.

The firm has a well-stocked legal library to assist partners and professional legal staff in their work.</p>
          </div>
          <div className="interactive-element">
            <div className="hover-circle"></div>
            <div className="hover-circle"></div>
          </div>
        </div>
      </section>

    </div>
            <Footer />
    </div>
  );
};

export default Quality;